"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.shoutouts = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
const app_1 = require("../app");
const shoutouts_1 = require("../firestore/shoutouts");
// eslint-disable-next-line @typescript-eslint/no-namespace
var shoutouts;
(function (shoutouts) {
    class CreateRequestRequest extends toccata_1.Model {
    }
    __decorate([
        (0, toccata_1.TransformValidateModel)(shoutouts_1.RequestForm)
    ], CreateRequestRequest.prototype, "form", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], CreateRequestRequest.prototype, "shoutoutId", void 0);
    shoutouts.CreateRequestRequest = CreateRequestRequest;
    class CreateRequestResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsOptional()
    ], CreateRequestResponse.prototype, "requestId", void 0);
    __decorate([
        toccata_1.validator.IsBoolean()
    ], CreateRequestResponse.prototype, "success", void 0);
    shoutouts.CreateRequestResponse = CreateRequestResponse;
    class CreateShoutoutResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString(),
        toccata_1.validator.IsOptional()
    ], CreateShoutoutResponse.prototype, "shoutoutId", void 0);
    __decorate([
        toccata_1.validator.IsBoolean()
    ], CreateShoutoutResponse.prototype, "success", void 0);
    shoutouts.CreateShoutoutResponse = CreateShoutoutResponse;
    class SetPhoneRequest extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsString()
    ], SetPhoneRequest.prototype, "requestId", void 0);
    __decorate([
        toccata_1.validator.IsString()
    ], SetPhoneRequest.prototype, "paymentIntentId", void 0);
    __decorate([
        toccata_1.validator.IsPhoneNumber()
    ], SetPhoneRequest.prototype, "phoneNumber", void 0);
    shoutouts.SetPhoneRequest = SetPhoneRequest;
    class SetPhoneResponse extends toccata_1.Model {
    }
    __decorate([
        toccata_1.validator.IsBoolean()
    ], SetPhoneResponse.prototype, "success", void 0);
    shoutouts.SetPhoneResponse = SetPhoneResponse;
})(shoutouts = exports.shoutouts || (exports.shoutouts = {}));
function init(firebaseApp) {
    const functions = firebaseApp
        ? firebaseApp.functions()
        : app_1.app.firebase.functions();
    return {
        createRequest: (0, toccata_1.createFunction)(functions, 'shoutout-createRequest', shoutouts.CreateRequestRequest, shoutouts.CreateRequestResponse),
        createShoutout: (0, toccata_1.createFunction)(functions, 'shoutout-createShoutout', shoutouts_1.Shoutout, shoutouts.CreateShoutoutResponse),
        setPhone: (0, toccata_1.createFunction)(functions, 'shoutout-setPhone', shoutouts.SetPhoneRequest, shoutouts.SetPhoneResponse),
    };
}
exports.init = init;
//# sourceMappingURL=shoutouts.js.map